import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { debugLogPages } from "../../app/helpers/debugHelper";
import { getObjectByCode } from "../../app/helpers/getObjectByCode";
import { getObjectById } from "../../app/helpers/getObjectById";
import { getSectionHeader } from "../../app/helpers/helperValidationViewPreview";
import useFormValidations from "../../app/hooks/useFormValidations";
import { useHydrateViewCatalogRelations } from "../../app/hooks/useHydrateViewCatalogRelations";
import { startLoadingCatalogCiiusAll } from "../../app/actions/catalogCiiuActions";
import { startLoadingContinents } from "../../app/actions/continentActions";
import { startLoadingRegions } from "../../app/actions/regionActions";
import { startLoadingCountries } from "../../app/actions/countryActions";
import IntegrationViewChrome from "../end-user-search/IntegrationViewChrome";
import { useIntegrationNestedPreview } from "../end-user-search/integrationNestedPreviewContext";
import DetailSectionsLayout from "../end-user-search/DetailSectionsLayout";
import NavbarIconsAssistance from "../generic-nav-bar/NavbarIconsAssistance";
import FlowEngineSection from "../specialist-flow-engine/FlowEngineSection";

const ViewAssistance = () => {
  debugLogPages(':: ViewAssistance');

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { nested, setDetailMode } = useIntegrationNestedPreview();

  /********Store*******/
  const { assistanceSelected } = useSelector((state) => state.assistance);

  const { listFullCatalogCiius } =
    useSelector((state) => state.catalogCiiu);

  const { listFullCatalogInstitutions } =
    useSelector((state) => state.catalogInstitution);

  const { listContinents, listFullRegions } = useSelector((state) => state.locationCountry);

  const { listFieldsAssistanceView, listFieldsAssistancePreview } = useSelector((state) => state.moduleConfig);

  /********UseForm*******/
  const { values, handleChangeCatalogCiiu, handleChangeCatalogInstitution, setValues } = useFormValidations(
      () => AssistanceCallback(),
      assistanceSelected,
      listFieldsAssistanceView
    );

  const AssistanceCallback = () => {
    
  };

  useHydrateViewCatalogRelations('Assistance', values, setValues);

  useEffect(() => {
    if (!nested) return undefined;
    dispatch(startLoadingCatalogCiiusAll());
    dispatch(startLoadingContinents());
    dispatch(startLoadingRegions());
    dispatch(startLoadingCountries());
    return undefined;
  }, [nested, dispatch]);

  useEffect(() => {
    
    if (values && values.catalogciius_id && listFullCatalogCiius) {
      let codigosCiius = values.catalogciiu_levels;

      let partes = codigosCiius.split(";");

      var objectCiiuFound = [];

      var currentCatalogCiiuLevelInValues = {
        1: values.catalogciiu_level1,
        2: values.catalogciiu_level2,
        3: values.catalogciiu_level3,
        4: values.catalogciiu_level4,
        5: values.catalogciiu_level5,
        6: values.catalogciiu_level6,
      };

      for (let i = 0; i < partes.length; i++) {

        objectCiiuFound[i] = getObjectByCode(partes[i], listFullCatalogCiius);
        
        handleChangeCatalogCiiu(objectCiiuFound[i], i + 1);

        currentCatalogCiiuLevelInValues[i + 1] = objectCiiuFound[i].id;
      }
    }

  }, [listFullCatalogCiius]);

  useEffect(() => {

      if (values && values.cataloginstitutions_id && listFullCatalogInstitutions) {
        let codigosInstitutions = values.cataloginstitution_levels;

        let partes = codigosInstitutions.split(";");

        var objectInstitutionFound = [];
  
        var currentCatalogInstitutionLevelInValues = {
          1: values.cataloginstitution_level1,
          2: values.cataloginstitution_level2,
          3: values.cataloginstitution_level3,
          
        };

        for (let i = 0; i < partes.length; i++) {
          objectInstitutionFound[i] = getObjectByCode(partes[i], listFullCatalogInstitutions);
          
          handleChangeCatalogInstitution(objectInstitutionFound[i], i + 1);
  
          currentCatalogInstitutionLevelInValues[i + 1] = objectInstitutionFound[i].id;
        }
      }
  
    }, [listFullCatalogInstitutions]);

  useEffect(() => {
  
      if (values && values.catalogregions_id && listFullRegions) {
        
        const elementFoundLevel = getObjectById(values.catalogregions_id, listFullRegions);

        setValues((values) => ({ ...values, 'CatalogRegion_To_Assistance': elementFoundLevel }));
        
      }
  
      if (values && values.catalogcontinents_id && listContinents) {

        const elementFoundLevel = getObjectById(values.catalogcontinents_id, listContinents);

        setValues((values) => ({ ...values, 'CatalogContinent_To_Assistance': elementFoundLevel }));
        
      }
  
    }, [listFullRegions,listContinents, values.catalogcontinents_id, values.catalogregions_id]);

  const { arrayListPrincipal, arrayListSecondary } = listFieldsAssistancePreview;

  const assistanceViewRelations = {
    multimedia: "ModuleFile_To_Assistance",
    problems: "ModuleProblem_To_Assistance"
  };

  const sharedViewProps = {
    values,
    t,
    ProblemTableComponent: null, // Mantiene la tabla comentada/desactivada de manera limpia
    relationKeys: assistanceViewRelations,
    isPreviewMode: false // Filtra mediante show_view_full
  };

      const principalHeader = getSectionHeader(arrayListPrincipal);
      const secondaryHeader = getSectionHeader(arrayListSecondary);

  const onGoSummaryVersion = (e) => {
    if (!nested || !setDetailMode) return;
    e.preventDefault();
    setDetailMode('preview');
  };

  return (
    <div>
      {!nested && <NavbarIconsAssistance page={"viewText"} />}

      {!nested && (
        <IntegrationViewChrome
          sourceModuleKey="assistance"
          record={assistanceSelected}
        />
      )}

      <div className="d-flex justify-content-center page-title">{t("assistance.view.title")}</div>
      <hr className="line-hr" />
      <div className="section is-fullheight">
        <div className="container">
          <form>
            <div className="container-fluid">
              <div className="text-center fw-bolder">
                <div className="text-center">
                  {nested ? (
                    <button
                      type="button"
                      className="btn btn-link p-0 fw-bolder"
                      onClick={onGoSummaryVersion}
                    >
                      {t("assistance.view.redirect")}
                    </button>
                  ) : (
                    <Link to="/end-user-search/preview-assistance">
                      {t("assistance.view.redirect")}
                    </Link>
                  )}
                </div>
              </div>
              <DetailSectionsLayout
                nested={nested}
                isPreviewMode={false}
                arrayListPrincipal={arrayListPrincipal}
                arrayListSecondary={arrayListSecondary}
                principalHeader={principalHeader}
                secondaryHeader={secondaryHeader}
                sharedViewProps={sharedViewProps}
              />
            </div>

            <FlowEngineSection
              record={assistanceSelected}
              moduleProcess="assistance"
              moduleName={t("assistance.view.title")}
              onAfterAction={() => {}}
            />
          </form>
        </div>
      </div>
    </div>
  );
};

export default ViewAssistance;
